export interface AttachmentListItemDto {
    attachmentId: string;
    fileName: string;
    fileType: string;
    description?: string;
    relatedObjectType: string;
    relatedObjectId: string;
    ownerId: string;
    createdDateTime: string;
    createdEmployeeId: string;
}

export interface AttachmentDto {
    relatedObjectType: string;
    relatedObjectId: string;
}

export const RelatedObjectTypeVehicleMaintenance = "VehicleMaintenance";
export const RelatedObjectTypeTransportOrder = "TransportOrder";
